const applyFlagshipPrefix = (subject: string): string => {
  if (process.env.GATSBY_ENVIRONMENT === "production") {
    return `gyms_production_${subject}`;
  } else {
    return `gyms_staging_${subject}`;
  }
};

export default applyFlagshipPrefix;
